module.exports = __webpack_public_path__ + "static/img/蒙版组 265@2x.08187cab.png";